import React, { Component } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import distanceInWords from 'date-fns/distance_in_words';
import colors from '../../../styling/colors';
import HandOffLink from '../../../utils/urls/HandOffLink';

const NotificationLink = styled(HandOffLink)`
  background-color: ${colors('white')};
  display: block;
  width: 100%;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.75rem 0.75rem 0.5rem;
  border-bottom: 1px solid ${colors('alto')};
  cursor: pointer;

  :last-child {
    border: 0;
  }

  &:hover {
    background-color: ${colors('dove')};
  }
`;

const NotificationText = styled.span`
  font-weight: ${({ readAt }) => (!readAt ? '500' : '300')};
`;

const NotificationTime = styled.div`
  font-size: 0.75rem;
  color: ${colors('boulder')};
`;

export default class Notification extends Component {
  static propTypes = {
    link: PropTypes.string,
    notifierName: PropTypes.string,
    action: PropTypes.string,
    parentObjectName: PropTypes.string,
    directNotifiedAt: PropTypes.string,
    readAt: PropTypes.string,
    onNotificationClick: PropTypes.func,
  };

  render() {
    const {
      link,
      notifierName,
      action,
      parentObjectName,
      directNotifiedAt,
      readAt,
      onNotificationClick,
    } = this.props;

    return (
      <NotificationLink
        href={link}
        identifier="notifications"
        preRedirects={[() => onNotificationClick()]}
      >
        <NotificationText readAt={readAt}>
          {notifierName + ' ' + action + ' ' + parentObjectName}
        </NotificationText>
        <NotificationTime>
          {distanceInWords(Date.now(), directNotifiedAt, { addSuffix: true })}
        </NotificationTime>
      </NotificationLink>
    );
  }
}
